interface ICompareAppVersionProps {
  appVersion: string;
  baseVersion: string;
}
export default class EnvHelper {
  static getPlatformString(): string {
    return window.appEnvironment?.platform || '';
  }
  static getUserAgentString(): string {
    return window.appEnvironment?.fkUA || window.navigator.userAgent;
  }

  // Taken from RV https://github.fkinternal.com/Flipkart/fk-cp-richviews/blob/30c3d7cb057127475f58d2eb8d67cca63f74d334/packages/common/utils/UAHelper.js#L63-L69

  static getAppVersion = () => {
    const userAgent = EnvHelper.getUserAgentString();

    if (userAgent) {
      const userAgentArray = userAgent.split(' ');
      for (var i = 0; i < userAgentArray.length; i++) {
        if (userAgentArray[i].indexOf('FKUA') !== -1) {
          const userAgentString = userAgentArray[i];
          const stringsArray = userAgentString.split('/');
          return stringsArray[2];
        }
      }
    }
    return null;
  };

  static compareAppVersion({
    appVersion,
    baseVersion
  }: ICompareAppVersionProps) {
    if (!appVersion || !baseVersion) return false;
    if (appVersion === baseVersion) return true;

    const appV = appVersion.split('.'),
      valueV = baseVersion.split('.');

    /**
     * checking if the user of this class is calling with absolute
     * app numbers like 93xxxx or 99xxxx and not x.y.z
     **/
    if (appV.length === 1 && valueV.length === 1) {
      return parseInt(appV[0]) > parseInt(valueV[0]);
    }

    /**
     * string to string comparison was breaking when
     * appVersion length was more than value length
     **/
    for (let index = 0; index <= appV.length; index++) {
      const currentVal: any = appV[index] && parseInt(appV[index]);
      const supportedVal: any = valueV[index] && parseInt(valueV[index]);
      if (
        isNaN(currentVal) ||
        isNaN(supportedVal) ||
        currentVal < supportedVal
      ) {
        return false;
      }
      if (
        currentVal > supportedVal &&
        (index === 0 || appV[index - 1] === valueV[index - 1])
      ) {
        return true;
      }
    }
    return false;
  }
}
